import React from 'react';
import './GeneralDocs.css'; 
import blinksNavigateWeb from '../assets/blinks_navigateweb.png';
import blinksSplitLead from '../assets/blinks_splitlead.png';
import blinksScroll from '../assets/blinks_scroll.png';
import blinksMouse from '../assets/blinks_mouse.png';


const ModesBlinks = () => {
  return (
    <div className="docs-page-container">
      <h1>Blinks Modes Examples</h1>
      
      <h2>An approach to a Keyboard mode</h2>
      <p>
      My personal approach to be able to write effectively is using Morse code with a few changes.
      Morse code maps a 2 input sistem (like a blink and a double-blink) to the letters of the alphabet. 
      With Morse, you can write every letter of the alphabet with 4 inputs or less. 
      But Morse may present some issues:
      <ul>
        <li>
        In Morse, "e" is mapped to 0 and "i" is mapped to 00. This will bring unwanted triggers when blinking normally.
        </li>
        <li>
        In order to properly write we also need inputs different than letters like the space or delete keys. 
        </li>
      </ul>
      
      Morse code also has 4 combinations of 4 inputs or less that are not used in Morse and that we can take advantage of.
      The changes that go well for me are the following:
      </p>

      <ul>
        <li>
          <b>e</b>: input will be 0011 instead of 0.
        </li>
        <li>
          <b>i</b>: input will be 0101 instead of 00.
        </li>
        <li>
          <b>Space</b>: input will be 00.
        </li>
        <li>
          <b>Delete</b>: input will be 1110.
        </li>
        <li>
          <b>Enter</b>: input will be 1111.
        </li>
      </ul>   


      <h2> SplitLead + Mouse</h2>
      <p> A SplitLead mode with all the normal functionalities of a mouse.</p>
      <img src={blinksSplitLead} alt="Custom Mode Example" className="mode-image" />

      <h2> Navigate Web</h2>
      <p> A mode  with all the necessary to use a web browser, like mouse functionalities or special keys to 
      enable full screen, change tabs, close tabs...</p>
      <img src={blinksNavigateWeb} alt="Custom Mode Example" className="mode-image" />

      <h2> Mouse</h2>
      <p> Simple mode with GazeLead and all the most common mouse inputs.
      </p>
      <img src={blinksMouse} alt="Custom Mode Example" className="mode-image" />

      <h2> Scroll</h2>
      <p> Simple mode with scroll functionalities.</p>
      <img src={blinksScroll} alt="Custom Mode Example" className="mode-image" />

    </div>
  );
};

export default ModesBlinks;
